var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"lz-resource-action"},[_c('b-button',{on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('b-icon',{attrs:{"icon":_vm.icon,"scale":"0.8","aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }